import React from 'react';
import { Icon } from '@adobe/react-spectrum';

interface CommentIconProps
  extends Omit<React.ComponentProps<typeof Icon>, 'children'> {
  badgeCount?: number;
  width?: number | string;
  height?: number | string;
  children?: React.ReactNode;
}

const CommentIcon: React.FC<CommentIconProps> = ({
  badgeCount,
  width = 18,
  height = 17,
  ...rest
}) => {
  const showBadge = typeof badgeCount === 'number' && badgeCount > 0;
  const displayCount = showBadge
    ? badgeCount! > 99
      ? '99+'
      : String(badgeCount)
    : '';
  // Scale badge relative to icon size
  const numericWidth =
    typeof width === 'number' ? width : parseInt(String(width), 10) || 18;
  const badgeSize = Math.max(10, Math.min(14, Math.round(numericWidth * 0.8)));
  const badgeFontSize = Math.max(7, Math.min(11, Math.round(badgeSize * 0.65)));
  const badgeOffset = -Math.round(badgeSize * 0.4);

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex'
      }}
    >
      {/* <Icon {...rest}> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width as number}
          height={height as number}
          viewBox="0 0 18 17"
          fill="none"
        >
          <path
            d="M5.25 17C5.15088 17 5.05127 16.9805 4.95654 16.9404C4.67968 16.8223 4.5 16.5508 4.5 16.25V13H3.75C1.68213 13 0 11.3174 0 9.25V3.75C0 1.68262 1.68213 0 3.75 0H14.25C16.3179 0 18 1.68262 18 3.75V9.25C18 11.3174 16.3179 13 14.25 13H9.70703L5.77002 16.79C5.62744 16.9277 5.44043 17 5.25 17ZM3.75 1.5C2.50928 1.5 1.5 2.50977 1.5 3.75V9.25C1.5 10.4902 2.50928 11.5 3.75 11.5H5.25C5.66406 11.5 6 11.8359 6 12.25V14.4873L8.88477 11.71C9.02442 11.5752 9.21094 11.5 9.40479 11.5H14.25C15.4907 11.5 16.5 10.4902 16.5 9.25V3.75C16.5 2.50977 15.4907 1.5 14.25 1.5H3.75Z"
            fill="#292929"
          />
        </svg>
      {/* </Icon> */}
      {showBadge && (
        <span
          style={{
            position: 'absolute',
            top: badgeOffset,
            right: badgeOffset,
            minWidth: badgeSize,
            height: badgeSize,
            padding: `0 ${Math.max(2, Math.round(badgeSize * 0.25))}px`,
            borderRadius: Math.round(badgeSize / 2),
            background: '#0265DC',
            color: '#FFFFFF',
            fontFamily: 'Adobe Clean',
            fontSize: badgeFontSize,
            fontWeight: 700,
            lineHeight: `${badgeSize}px`,
            textAlign: 'center',
            boxSizing: 'border-box'
          }}
          aria-label={`${displayCount} comments`}
        >
          {displayCount}
        </span>
      )}
    </span>
  );
};

export default CommentIcon;
